import React, { useState, useEffect } from 'react';
import { Box, Button, useTheme } from '@mui/material';
import Toast from './Toast';

const ApprovalSettings = ({ approvals, organization }) => {
    const theme = useTheme();
    const isLight = theme.palette.mode === 'light';
    const textColor = isLight ? '#0F172A' : '#FFFFFF';
    const subTextColor = isLight ? '#334155' : 'rgba(255, 255, 255, 0.85)';
    const borderColor = isLight ? '#E2E8F0' : 'rgba(255, 255, 255, 0.1)';

    const [toast, setToast] = useState({ open: false, message: '', severity: 'success' });



    const [prayerApproval, setPrayerApproval] = useState('no');
    const [prayerBv, setPrayerBv] = useState('yes');
    const [testimonyApproval, setTestimonyApproval] = useState('no');
    const [testimonyBv, setTestimonyBv] = useState('no');
    const [backgroundVerify, setBackgroundVerify] = useState('no');
    const [backgroundBv, setBackgroundBv] = useState('no');
    const [userAccountBv, setUserAccountBv] = useState('no');


    const [rideApproval, setRideApproval] = useState('no');
    const [rideBv, setRideBv] = useState('no');

    const [giverItemsApproval, setGiverItemsApproval] = useState('no');
    const [GiverItemBv, setGiverItemBv] = useState('no');

    const [newItemRequestsApproval, setNewItemRequestsApproval] = useState('no');
    const [NewItemRequestsBv, setNewItemRequestsBv] = useState('no');


    const [userAccountApproval, setUserAccountApproval] = useState('no'); // Added state for User Account Approval
    const API_URL = process.env.REACT_APP_API_URL || 'http://45.194.3.128:4000/api/admin/';

    useEffect(() => {
        if (approvals) {

            //     console.log(approvals, organization);

            setPrayerApproval(approvals.prayer?.approval || "no");
            setPrayerBv(approvals.prayer?.bv_status !== undefined && approvals.prayer?.bv_status !== null ? approvals.prayer.bv_status : "yes");

            setTestimonyApproval(approvals.testimony?.approval || "no");
            setTestimonyBv(approvals.testimony?.bv_status || "no");

            setBackgroundVerify(approvals.backgroundVerification?.approval || "no");

            setRideApproval(approvals.rider?.approval || "no");
            setRideBv(approvals.rider?.bv_status || "no");

            setGiverItemsApproval(approvals.giverItems?.approval || "no");
            setNewItemRequestsApproval(approvals.newItemRequests?.approval || "no");

            setUserAccountApproval(approvals.userAccount?.approval || "no");
        }
    }, [approvals]);

    const SaveApprovalSettings = async () => {
        const token = localStorage.getItem('token');

        const approvals = {
            prayer: {
                approval: prayerApproval,
                bv_status: prayerBv,
            },
            testimony: {
                approval: testimonyApproval,
                bv_status: testimonyBv,
            },
            backgroundVerification: {
                approval: backgroundVerify,
                bv_status: backgroundBv,
            },
            rider: {
                approval: rideApproval,
                bv_status: rideBv,
            },
            giverItems: {
                approval: giverItemsApproval,
                bv_status: GiverItemBv,
            },
            newItemRequests: {
                approval: newItemRequestsApproval,
                bv_status: NewItemRequestsBv,
            },
            userAccount: {
                approval: userAccountApproval,
                bv_status: userAccountBv,
            },
        };

        const response = await fetch(`${API_URL}update-approval-settings`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify({
                approvals,
                org_id: organization
            }),
        });
        if (response.ok) {
            setToast({ open: true, message: "Settings saved successfully!", severity: "success" });
            setTimeout(() => window.location.reload(), 1000);
        }
        else {
            const errorData = await response.json();
            setToast({ open: true, message: `Error saving settings: ${errorData.message}`, severity: "error" });
        }
    };

    return (
        <section style={{
            background: isLight ? "#FFFFFF" : "rgba(255, 255, 255, 0.05)",
            backdropFilter: "blur(20px)",
            border: `1px solid ${borderColor}`,
            borderRadius: 12,
            boxShadow: isLight ? "0 4px 20px rgba(0, 0, 0, 0.05)" : "0 8px 32px rgba(0, 0, 0, 0.2)",
            padding: 24,
            color: textColor,
            gap: 24
        }}>
            <div data-testid="user-account-module" style={{ marginTop: 24, borderBottom: `1px solid ${borderColor}`, paddingBottom: 16, color: textColor }}>
                <div style={{ fontWeight: 600, fontSize: 18, marginBottom: 12, color: textColor }}>Users</div>
                <div style={{ marginBottom: 16, display: "flex", alignItems: "center", gap: 20 }}>
                    <label style={{ fontWeight: 500, color: subTextColor }}>All Users need admin approval?</label>

                    <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                        <label className="switch">
                            <input
                                type="checkbox"
                                checked={userAccountApproval === "yes"}
                                onChange={e => setUserAccountApproval(e.target.checked ? "yes" : "no")}
                                aria-label="User account approval toggle"
                            />
                            <span className="slider"></span>
                        </label>
                    </div>
                </div>
            </div>

            <div data-testid="prayer-module" style={{ marginTop: 24, borderBottom: `1px solid ${borderColor}`, paddingBottom: 16, color: textColor }}>
                <div style={{ fontWeight: 600, fontSize: 18, marginBottom: 12, color: textColor }}>Prayer Module</div>
                <div style={{ marginBottom: 16, display: "flex", alignItems: "center", gap: 20 }}>
                    <label style={{ fontWeight: 500, color: subTextColor }}>Prayer post needs approval?</label>

                    <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                        <label className="switch">
                            <input
                                type="checkbox"
                                checked={prayerApproval === "yes"} // convert "yes"/"no" to boolean
                                onChange={e => setPrayerApproval(e.target.checked ? "yes" : "no")} // convert boolean to "yes"/"no"

                                aria-label="Prayer approval toggle"
                            />
                            <span className="slider"></span>
                        </label>
                    </div>

                </div>

                <div style={{ marginTop: 12, paddingLeft: 8 }}>
                    <label style={{ display: "flex", alignItems: "center", cursor: "pointer", color: subTextColor, fontWeight: 500 }}>
                        <input
                            type="checkbox"
                            checked={prayerBv !== "no"} // checked by default
                            onChange={e => setPrayerBv(e.target.checked ? "yes" : "no")}
                            style={{ marginRight: 10, width: 17, height: 17, accentColor: '#0D9488', cursor: 'pointer' }}
                            aria-label="Only verified users can post without admin approval toggle"
                        />
                        Only Verified Users Can Post Without Admin Approval
                    </label>
                    <div style={{ fontSize: 13, color: isLight ? '#64748B' : 'rgba(255, 255, 255, 0.65)', marginTop: 4, marginLeft: 27 }}>
                        {prayerBv !== 'no' 
                            ? 'Verified believers post immediately without manual moderation. Unverified users must wait for admin decision in Approval Center.'
                            : 'All users can submit prayers without manual admin approval.'}
                    </div>
                </div>
            </div>






            <div data-testid="testimony-module" style={{ marginTop: 24, borderBottom: `1px solid ${borderColor}`, paddingBottom: 16 }}>
                <div style={{ fontWeight: 600, fontSize: 18, marginBottom: 12, color: textColor }}>Testimony Module</div>
                <div style={{ marginBottom: 16, display: "flex", alignItems: "center", gap: 20 }}>
                    <label style={{ fontWeight: 500, color: subTextColor }}>Testimony post needs approval?</label>

                    <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                        <label className="switch">
                            <input type="checkbox"
                                checked={testimonyApproval === "yes"} // convert "yes"/"no" to boolean
                                onChange={e => setTestimonyApproval(e.target.checked ? "yes" : "no")}
                                aria-label="Testimony approval toggle"
                            />
                            <span className="slider"></span>
                        </label>
                    </div>

                </div>

                {testimonyApproval === 'yes' && (
                    <div>
                        <label style={{ color: subTextColor }}>
                            <input
                                type="checkbox"

                                checked={testimonyBv === "yes"} // convert to boolean
                                onChange={e => setTestimonyBv(e.target.checked ? "yes" : "no")} // convert back to "yes"/"no"
                                style={{ marginRight: 8 }}
                            />
                            Exclude those with Background verification
                        </label>
                    </div>
                )}
                {testimonyApproval === 'no' && (

                    <div>
                        <label style={{ color: subTextColor }}>
                            <input
                                type="checkbox"
                                checked={testimonyBv === "yes"} // convert to boolean
                                onChange={e => setTestimonyBv(e.target.checked ? "yes" : "no")} // convert back to "yes"/"no"
                                style={{ marginRight: 8 }}
                            />
                            Include those without Background verification
                        </label>
                    </div>
                )}
            </div>


            <div data-testid="background-module" style={{ marginTop: 24, borderBottom: `1px solid ${borderColor}`, paddingBottom: 16 }}>
                <div style={{ fontWeight: 600, fontSize: 18, marginBottom: 12, color: textColor }} aria-label="Background Verification Module">Background Verification</div>
                <div style={{ marginBottom: 16, display: "flex", alignItems: "center", gap: 20 }}>
                    <label style={{ fontWeight: 500, color: subTextColor }}>Is Background verification needed?</label>

                    <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                        <label className="switch">
                            <input type="checkbox"

                                checked={backgroundVerify === "yes"} // convert "yes"/"no" to boolean
                                onChange={e => setBackgroundVerify(e.target.checked ? "yes" : "no")}
                                aria-label="Background toggle"
                            />
                            <span className="slider"></span>
                        </label>
                    </div>

                </div>
            </div>


            <div data-testid="ride-module" style={{ marginTop: 24, borderBottom: `1px solid ${borderColor}`, paddingBottom: 16 }}>
                <div style={{ fontWeight: 600, fontSize: 18, marginBottom: 12, color: textColor }}>Give Ride/ Get Ride</div>
                <div style={{ marginBottom: 16, display: "flex", alignItems: "center", gap: 20 }}>
                    <label style={{ fontWeight: 500, color: subTextColor }}>Rider need approval?</label>

                    <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                        <label className="switch">
                            <input type="checkbox"
                                checked={rideApproval === "yes"} // convert "yes"/"no" to boolean
                                onChange={e => setRideApproval(e.target.checked ? "yes" : "no")}
                                aria-label="Ride approval toggle"
                            />
                            <span className="slider"></span>
                        </label>
                    </div>

                </div>
                {rideApproval === 'yes' && (

                    <div>
                        <label style={{ color: subTextColor }}>
                            <input
                                type="checkbox"

                                checked={rideBv === "yes"} // convert to boolean
                                onChange={e => setRideBv(e.target.checked ? "yes" : "no")} // convert back to "yes"/"no"

                                style={{ marginRight: 8 }}
                            />
                            Exclude those with Identity verification
                        </label>
                    </div>
                )}
                {rideApproval === 'no' && (

                    <div>
                        <label style={{ color: subTextColor }}>
                            <input
                                type="checkbox"
                                checked={rideBv === "yes"} // convert to boolean
                                onChange={e => setRideBv(e.target.checked ? "yes" : "no")} // convert back to "yes"/"no"
                                style={{ marginRight: 8 }}
                            />
                            Include those without Identity verification
                        </label>
                    </div>
                )}
            </div>


            <div data-testid="giver-items-module" style={{ marginTop: 24, borderBottom: `1px solid ${borderColor}`, paddingBottom: 16 }}>
                <div style={{ fontWeight: 600, fontSize: 18, marginBottom: 12, color: textColor }}>Giver Items</div>
                <div style={{ marginBottom: 16, display: "flex", alignItems: "center", gap: 20 }}>
                    <label style={{ fontWeight: 500, color: subTextColor }}>Giver Items need approval?</label>

                    <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                        <label className="switch">
                            <input type="checkbox"
                                checked={giverItemsApproval === "yes"}
                                onChange={e => setGiverItemsApproval(e.target.checked ? "yes" : "no")}
                                aria-label="Giver Items approval toggle"
                            />
                            <span className="slider"></span>
                        </label>
                    </div>

                </div>
            </div>


            <div data-testid="new-item-requests-module" style={{ marginTop: 24, borderBottom: `1px solid ${borderColor}`, paddingBottom: 16 }}>
                <div style={{ fontWeight: 600, fontSize: 18, marginBottom: 12, color: textColor }}>New Item Requests</div>
                <div style={{ marginBottom: 16, display: "flex", alignItems: "center", gap: 20 }}>
                    <label style={{ fontWeight: 500, color: subTextColor }}>New Item Requests need approval?</label>

                    <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                        <label className="switch">
                            <input type="checkbox"
                                checked={newItemRequestsApproval === "yes"}
                                onChange={e => setNewItemRequestsApproval(e.target.checked ? "yes" : "no")}
                                aria-label="New Item Requests approval toggle"
                            />
                            <span className="slider"></span>
                        </label>
                    </div>

                </div>
            </div>

            <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mt: 2 }}>
                <Button
                    style={{
                        backgroundColor: "#c0c5cfff",
                        color: "#fff",
                        padding: "8px 16px",
                        border: "none",
                        borderRadius: 4,
                        cursor: "pointer",
                        fontWeight: 500,
                    }}
                    onClick={() => window.location.reload()}
                >
                    Cancel
                </Button>

                <Button variant="contained" sx={{ background: "#177373" }} onClick={SaveApprovalSettings}>
                    Save Settings
                </Button>
            </Box>
            <Toast toast={toast} setToast={setToast} />
        </section>
    );


}
export default ApprovalSettings;